<template>
  <el-dialog
      :title="title + '-' + materialName"
      :visible.sync="dialogVisible"
      width="1100px"
      top="2vh"
      @close="onDialogClose">
    <div class="vm-search">
      <vm-search label="条件">
        <el-input v-model.trim="filter.conditionText" clearable/>
      </vm-search>
      <el-button
          :loading="status==='loading'"
          type="primary"
          size="mini"
          style="height: 26px; padding: 0 10px; margin-left: 10px;"
          @click="getList(1)">
        查询
      </el-button>
    </div>
    <el-table v-loading="status==='loading'" :data="tableData" height="calc(100vh - 28vh)">
      <template slot="empty">
        <i v-if="status==='loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status==='error'" @click="getList">加载失败，点击重新获取</el-button>
        <div v-else-if="status==='empty'">暂无数据</div>
      </template>
      <el-table-column property="conditionText" label="条件">
        <template slot-scope="scope">
          <span style="color: #2d8cf0;cursor: pointer;" type="text" @click="$refs.priceApply.open(scope.row.productPriceID, id)"><span v-html="scope.row.conditionText"/></span>
        </template>
      </el-table-column>
      <el-table-column property="sellingPrice" label="标准价格" width="100"/>
      <el-table-column property="costPrice" label="成本价格" width="100"/>
      <el-table-column property="yiXinSettlementPrice" label="谊新结算价" width="100"/>
      <el-table-column property="sellingPriceLevel1" label="销售员" width="100"/>
      <el-table-column property="sellingPriceLevel2" label="区总" width="100"/>
      <el-table-column property="sellingPriceLevel3" label="总监" width="100"/>
    </el-table>
    <div style="margin-top: 16px;overflow: hidden">
      <el-pagination
          background
          class="page"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"/>
    </div>
    <price-apply ref="priceApply"/>
  </el-dialog>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import PriceApply from "@/views/information/ProductPrice/PriceApply";

  export default {
    name:"PriceDetail",
    components: {PriceApply, VmSearch},
    data() {
      return {
        dialogVisible: false,
        currentPage: 1,
        total: 0,
        pageNum: 1,
        pageSize: 10,
        status: "loading",
        id: 0,
        materialName: "",
        title: "产品价格表",
        tableData:[],
        filter: {
          conditionText: "",
        },
      };
    },
    methods: {
      open(id, materialName) {
        this.dialogVisible = true;
        this.id = id;
        this.materialName = materialName;
        if (id > 0) {
          this.getList(1);
        }
      },
      handleCurrentChange(pageNum) {
        this.getList(pageNum);
      },
      getList(pageNum) {
        this.status = "loading";
        let params = {
          "conditionText": this.filter.conditionText,
          "pageNum": pageNum,
          "pageSize": this.pageSize,
        };
        this.$http
          .get("basic", `material_prices/list/${this.id}`, params)
          .then(data => {
            this.tableData = data.records;
            this.total = data.total;
            if (this.total === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          }).catch(() => {
            this.status = "error";
          });
      },
      onDialogClose() {
        this.id = 0;
        this.pageNum = 1;
        this.pageSize = 10;
        this.materialName = "";
        this.dialogVisible = false;
        this.tableData = [];
      },
    },
  };
</script>

<style scoped>
  .vm-search {
    margin: 0 0 10px 10px;
  }
</style>
